export default () => ({
  staticPickerWrapper: {
    '& .PrivatePickersSlideTransition-root': {
      minHeight: 40 * 6,
      display: 'flex',
      alignItems: 'center',
    },
    '& .PrivatePickersSlideTransition-root [role="grid"]': {
      width: '100%',
    },
    '& .PrivatePickersSlideTransition-root [role="row"]': {
      justifyContent: 'space-between',
    },
    '& .MuiCalendarPicker-root': {
      maxHeight: 375,
    },
    '& .MuiPickerStaticWrapper-root>div>div': {
      maxHeight: 375,
    },
    '& .MuiCalendarPicker-root>div>div': {
      justifyContent: 'space-between',
    },
    '& .MuiCalendarPicker-root>div': {
      paddingLeft: 5,
      paddingRight: 5,
    },
    '& .MuiPickersDay-root': {
      width: 40,
      height: 40,
    },
  },
});
